<svg 
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 24 24">    
    <path d="M14,19H18V5H14M6,19H10V5H6V19Z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-pause.html